import { render, staticRenderFns } from "./SameIcon.vue?vue&type=template&id=2c27960c"
import script from "./SameIcon.vue?vue&type=script&lang=js"
export * from "./SameIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports